__turbopack_context__.v({
  "alternateUnits": "PowerFilter-module__wsZ_tq__alternateUnits",
  "auxInfo": "PowerFilter-module__wsZ_tq__auxInfo",
  "conditionTypeBtns": "PowerFilter-module__wsZ_tq__conditionTypeBtns",
  "infoLine": "PowerFilter-module__wsZ_tq__infoLine",
  "powerFilter": "PowerFilter-module__wsZ_tq__powerFilter",
  "rangeInput": "PowerFilter-module__wsZ_tq__rangeInput",
  "rangeInputControl": "PowerFilter-module__wsZ_tq__rangeInputControl",
  "resultCount": "PowerFilter-module__wsZ_tq__resultCount",
  "stepperWrapper": "PowerFilter-module__wsZ_tq__stepperWrapper",
});
